import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacilityIconComponent } from './facility-icon.component';

@NgModule({
  declarations: [FacilityIconComponent],
  exports: [
    FacilityIconComponent
  ],
  imports: [
    CommonModule
  ]
})
export class FacilityIconModule { }
